import { ExclamationCircleOutlined } from '@ant-design/icons';
import { PageHeader } from '@organisms';
import {
  usePageListColumnOrder,
  usePageListColumnVisibility,
} from '@templates';
import { Flex } from 'antd';
import { FC, useEffect } from 'react';

import { ModalAlert } from 'src/app/framework/molecules/ModalAlert/ModalAlert.molecule';
import { useBreadcrumbs } from 'src/features/layout/hooks/useBreadcrumbs';

import { OfferActions } from '../../components/offerExhibitions/OfferActions';
import {
  OFFER_COLUMN_VISIBILITY_CONFIG,
  OFFER_DRAG_COLUMN_STORAGE_KEY,
  OFFER_FIXED_COLUMN_KEYS,
  TableOffer,
} from '../../components/offerExhibitions/OfferTable';
import useOfferPage from '../../hooks/useOfferPage';
import { SkeletonOfferExhibition } from '../skeletonOfferExhibition';

export const OfferExhibition: FC = () => {
  const {
    offerList,
    handleChangeFilter,
    handleChangePagination,
    pageSize,
    currentPage,
    filter,
    headerColumns,
    product,
    isLoading,
    offerProperties,
    offerToExpire,
    setOfferToExpire,
    handleExpireOffer,
    isLoadingExpire,
    actionsOfferBulk,
    drawerOfferBulk,
    upsellFlowOptions,
  } = useOfferPage();
  const columnOrderState = usePageListColumnOrder(headerColumns, {
    enabled: true,
    persist: true,
    storageKey: OFFER_DRAG_COLUMN_STORAGE_KEY,
    fixedColumnKeys: OFFER_FIXED_COLUMN_KEYS,
  });
  const columnVisibilityState = usePageListColumnVisibility(
    columnOrderState.orderedColumns,
    OFFER_COLUMN_VISIBILITY_CONFIG
  );

  const setBreadCrumbs = useBreadcrumbs([
    {
      label: 'Produtos',
      route: '/products',
    },
    {
      label: `Ofertas`,
    },
  ]);

  useEffect(() => {
    if (product && !isLoading) {
      setBreadCrumbs([
        {
          label: 'Produtos',
          route: '/products',
        },
        {
          label: `Ofertas ${product?.name}`,
        },
      ]);
    }
  }, [product, isLoading]);

  return (
    <>
      {drawerOfferBulk}
      {isLoading ? (
        <SkeletonOfferExhibition
          columnsTable={columnVisibilityState.visibleColumns}
        />
      ) : (
        <>
          <PageHeader
            title={`Ofertas ${product?.name}`}
            subTitle={'Crie ou edite ofertas para este produto.'}
            extra={
              <OfferActions
                product={product}
                actionsOfferBulk={actionsOfferBulk}
              />
            }
          />
          <TableOffer
            data={offerList}
            offerProperties={offerProperties}
            initialFilters={filter}
            onChangeFilter={handleChangeFilter}
            onChangePagination={handleChangePagination}
            pageSize={pageSize}
            currentPage={currentPage}
            headerColumns={headerColumns}
            columnOrderState={columnOrderState}
            columnVisibilityState={columnVisibilityState}
            upsellFlowOptions={upsellFlowOptions}
          />

          <ModalAlert
            showModal={Boolean(offerToExpire)}
            confirmButtonAction={() => {
              if (!offerToExpire) return;
              handleExpireOffer(offerToExpire.id);
            }}
            icon={
              <ExclamationCircleOutlined
                style={{ color: '#D89614' }}
                size={24}
              />
            }
            denyButtonAction={() => {
              setOfferToExpire(undefined);
            }}
            isDangerConfirmButton
            hideCloseButtonHeader
            titleLabel={'Expirar Oferta'}
            confirmButtonLabel={`Expirar oferta`}
            messageLabel={
              <Flex style={{ marginLeft: 24 }} vertical>
                {`Ao expirar a oferta ${offerToExpire?.name}, ela não será mais acessível no checkout. Deseja continuar?`}
              </Flex>
            }
            isLoading={isLoadingExpire}
          />
        </>
      )}
    </>
  );
};
